import { ICommandBarItemProps, CommandBar } from '@fluentui/react';
import React from 'react';
import styles from './AppLayout.module.scss';
import { NavigateFunction, useNavigate } from "react-router-dom";

interface ITopNavigationProps { }

const DefaultCommandBarItem: (name: string, iconName: string) => ICommandBarItemProps = (name: string, iconName: string) => ({
  key: name,
  name: name,
  iconProps: { iconName: iconName },
});

export const TopNavigation : React.FunctionComponent<ITopNavigationProps> = (props: React.PropsWithChildren<ITopNavigationProps>) => {  
  const navigate: NavigateFunction = useNavigate();  

  const Commands: ICommandBarItemProps[] = [
    { ...DefaultCommandBarItem("Interessenter", "People"), onClick: () => { navigate("/interessenter"); } },
    { ...DefaultCommandBarItem("Køb & salg", "RealEstate"), onClick: () => { navigate("/køb-salg"); } },
    { ...DefaultCommandBarItem("Udbetalinger", "Money"), onClick: () => { navigate("/udbetalinger"); } },
    { ...DefaultCommandBarItem("Servicebreve & anpartskontrol", "Certificate"), onClick: () => { navigate("/servicebreve"); } },
    // { ...DefaultCommandBarItem("Anpartskontrol", "ActivateOrders"), onClick: () => { navigate("/anpartskontrol"); } },
    { ...DefaultCommandBarItem("Produktionsoversigt", "AreaChart"), onClick: () => { navigate("/produktionsoversigt"); } },
  ];
  
  const CreateFarMenuItems = [
    { ...DefaultCommandBarItem("Indstillinger", "Settings"), onClick: () => { navigate("/indstillinger"); } },
  ];
  
  return (         
            <div className={styles.TopNavigation}>            
              <CommandBar items={Commands} farItems={CreateFarMenuItems} />
            </div>
      );
  }

  export default TopNavigation;
